import React from 'react';

import braintree from 'braintree-web';
import { getCsrfToken } from '../helpers/GetCsrfToken';
import ContentPageWrapper from '../wrappers/PizzaExpress/PreOrder/ContentPageWrapper';
import DeviceId from '../flows/DeviceId';
import { logClientEvent } from '../helpers/ClientLog';
import { stringifyError } from '../helpers/serializeError';

export default class extends React.Component {
  async componentDidMount() {
    const { clientToken } = this.props;
    const { currency } = this.props.getCurrency();
    if (!clientToken) return;

    const google = window.google;

    

    var paymentsClient = new google.payments.api.PaymentsClient({
      environment: this?.props?.environment ?? "PRODUCTION"
    });

    const clientInstance = await braintree.client
      .create({
        authorization: clientToken
      });

    const googlePaymentInstance = await braintree.googlePayment.create({
      client: clientInstance,
      googlePayVersion: 2,
      googleMerchantId: this.props.merchantId
    });


    const button = paymentsClient.createButton({
      onClick: () => {
        /* Click handler */
      }
    });
    document.getElementById('button-container').appendChild(button);

    button.addEventListener('click', async event => {
      event.preventDefault();
      logClientEvent('Pay button clicked', { PaymentMethod: 'GooglePay' });

      var paymentDataRequest = googlePaymentInstance.createPaymentDataRequest(
        {
          transactionInfo: {
            currencyCode: currency,
            totalPriceStatus: 'FINAL',
            totalPrice: this.props.grandTotal
          },
          emailRequired: true,
          shippingAddressRequired: true
        }
      );

      paymentsClient.isReadyToPay({
        // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: googlePaymentInstance.createPaymentDataRequest()
          .allowedPaymentMethods,
        existingPaymentMethodRequired: false // Optional
      });

      let email = "";
      paymentsClient
        .loadPaymentData(paymentDataRequest)
        .then('api/Braintree/Pay')
        .then(async paymentData => {
          this.props.submitPayment();
          logClientEvent('Payment submitted', { PaymentMethod: 'GooglePay' });
          email = paymentData.email;
          return googlePaymentInstance.parseResponse(paymentData);
        })
        .then(payload => {

          const payments = async (payData) => {
      
            let dataresponse = await fetch('api/Braintree/Pay', {
              method: 'post',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': getCsrfToken(),
                'DEVICE_ID': DeviceId.DEVICE_ID
              },
              body: this.props.generatePaymentBody(payData, email)
            });
      
            let data = await dataresponse.json();
            if (data.success === true) {
              this.props.storeCustomerEmail(email);
              this.props.paymentSuccessful(data);
            } else {
              this.props.submitPaymentFail();
            }
      
          }
          if (payload.details.isNetworkTokenized === false) { // eligible for 3DS Verification 

            var threeDSecureParameters = {
              amount: this.props.grandTotal,
              nonce: payload.nonce,
              bin: payload.details.bin,
              email: (this.props.customer
                ? this.props.customer.emailAddress
                : email),
              onLookupComplete: (data, next) => {
                // use `data` here, then call `next()`
                next();
              }
            };

            braintree.threeDSecure.create({
              version: '2', // Will use 3DS 2 whenever possible
              client: clientInstance
            }).then(async threeDSecureInstance => {
              let threeDSecure = threeDSecureInstance;
              const payByCardContainer = document.getElementById(
                'pay-by-card-container'
              );

              threeDSecure.on(
                'authentication-iframe-available',
                async (event, next) => {
                  this.props.pausePaymentLoadingAnimation();
                  payByCardContainer.appendChild(event.element);
                  event.element.className = 'three-d-secure-container';
                  next();
                }
              );

              try {
                let response = await threeDSecure
                  .verifyCard(threeDSecureParameters)

                var liabilityShifted = response?.threeDSecureInfo?.liabilityShifted ?? response?.liabilityShifted;
                var liabilityShiftPossible = response?.threeDSecureInfo?.liabilityShiftPossible ?? response?.liabilityShiftPossible;
                var threeDSecureFailed = liabilityShiftPossible === true && liabilityShifted === false;

                logClientEvent(threeDSecureFailed ? '3DS failed - liability not shifted' : '3DS completed successfully', {
                  PaymentMethod: 'GooglePay',
                  LiabilityShifted: liabilityShifted,
                  LiabilityShiftPossible: liabilityShiftPossible,
                  Status: response?.threeDSecureInfo?.status
                });

                this.props.unpausePaymentLoadingAnimation();
                threeDSecure.teardown();
                var threeDSecureElem = document.getElementsByClassName(
                  'three-d-secure-container'
                )[0];
                if (!!threeDSecureElem) {
                  payByCardContainer.removeChild(threeDSecureElem);
                }

                payments(response);

              } catch (error) {
                console.log(error);
                var fullError = stringifyError(error);
                logClientEvent('3DS verification failed', {
                  PaymentMethod: 'GooglePay',
                  Name: error?.name ?? '',
                  Code: error?.code ?? '',
                  Type: error?.type ?? '',
                  Message: error?.message ?? '',
                  FullError: fullError
                });

                // Tear down 3DS / remove its iframe defensively - if this throws
                // (e.g. the 3DS session never started) it must not stop us from
                // clearing the loading state, otherwise the spinner shows forever.
                try {
                  threeDSecure.teardown();
                  var threeDSecureElem = document.getElementsByClassName(
                    'three-d-secure-container'
                  )[0];
                  if (!!threeDSecureElem) {
                    payByCardContainer.removeChild(threeDSecureElem);
                  }
                } catch (teardownError) {
                  console.log('3DS teardown failed', teardownError);
                }

                // Always stop the spinner and return to the payment page with an error.
                var failureMessage = fullError.indexOf('Unsupported card type') !== -1
                  ? 'Unsupported card type. Please try a different card.'
                  : 'There was a problem verifying your card. Please try again.';
                this.props.submitPaymentFail(failureMessage);
              }
            });
          } else {
              //console.log(payload);
              //payload.threeDSecureInfo.liabilityShiftPossible = false;
              //console.log(payload);
            payments(payload);
          }
        })
        .catch(err => {
          console.log(err);
          this.props.submitPaymentFail();
        });
    });
  }

  render() {
    const { clientToken } = this.props;
    return !clientToken
      ? (null)
      : (
        <div
          style={
            this.props.submittingPayment === true ? { display: 'none' } : {}
          }
          className="payment-type"
        >
          <div id="button-container"></div>
        </div>
      );
  }
}
